import CheckoutForm from '../../Components/checkout/Checkout';

const PageCheckout = () => {
  return <CheckoutForm />;
}

export default PageCheckout;